import { Log } from "@ryde/shared";

interface IMapRemoveTarget {
  _removed?: boolean;
  remove: () => unknown;
}

/**
 * MapLibre's `Map.remove` calls `painter.destroy()` / `_handlers.destroy()` and throws
 * `Cannot read properties of undefined (reading 'destroy')` when those internals were never
 * created (WebGL init failed) or were already torn down (context loss, a second remove).
 *
 * react-maplibre always ends a map with `destroy()` → `map.remove()`, so an uncaught throw
 * there takes down the whole route. Marker and Popup `remove` can throw the same way when the
 * map is already gone. Patching `remove` keeps those paths from becoming a white screen.
 */
export const applySafeMapRemove = (mapPrototype: IMapRemoveTarget): void => {
  const originalRemove = mapPrototype.remove;

  mapPrototype.remove = function safeMapRemove(this: IMapRemoveTarget) {
    if (this._removed) {
      return this;
    }

    try {
      return originalRemove.call(this);
    } catch (error) {
      this._removed = true;
      Log.warn("MapLibre remove failed", error);
      return this;
    }
  };
};
